import { BodyText } from "@/components/ui/Text";
import { cn } from "@/lib/utils";
import { Clock, Layers, Radio } from "lucide-react";
import { ChatFilterMode } from "../types/chatMessageTypes";

interface ChatModeBannerProps {
  filterMode: ChatFilterMode;
}

const MODE_CONFIG = {
  [ChatFilterMode.LIVE]: {
    icon: Radio,
    label: "Viewing live messages",
    className: "bg-success/10 text-success border-success/20",
  },
  [ChatFilterMode.ASYNC]: {
    icon: Clock,
    label: "Viewing async messages",
    className: "bg-secondary text-tertiary border-primary",
  },
  [ChatFilterMode.COMBINED]: {
    icon: Layers,
    label: "Viewing all messages",
    className: "bg-tertiary/50 text-tertiary border-primary",
  },
};

export const ChatModeBanner = ({ filterMode }: ChatModeBannerProps) => {
  const config = MODE_CONFIG[filterMode];
  const Icon = config.icon;

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-4 py-1.5 border-b",
        config.className,
      )}
    >
      <Icon className="w-3 h-3" />
      <BodyText size="xs">{config.label}</BodyText>
    </div>
  );
};
